import React from 'react';

const Home = () => {
    document.title = 'Home Page';
    return (
        <div style={{height: '100vh', textAlign: 'center'}}>
            <h1 className="pt-5">Home Page coming soon....</h1>
        </div>
    );
};

export default Home;